import "./togle_theme.css"
import {logError} from "../function.js";
$(document).ready(function () {
    function dark(){
        try {
            $(".menu_sub_dark").addClass("ds-none")
            $(".menu_sub_light").removeClass("ds-none")
            const theme="dark";
            $("html").addClass(theme)
            jqueryts.storage.local.put("theme", theme)
            document.cookie = "theme=dark; path=/";
        } catch (e) {
            logError(e)
        }
    }
    function light(){
        try {
            $(".menu_sub_light").addClass("ds-none")
            $(".menu_sub_dark").removeClass("ds-none")
            $("html").removeClass("dark")
            const theme="light";
            jqueryts.storage.local.put("theme", theme)
            document.cookie = "theme=light; path=/";
        } catch (e) {
            logError(e)
        }
    }
    $(".menu_sub_dark").on( "click", function() {
        dark();
    })
    $(".menu_sub_light").on( "click", function() {
        light();
    })
    // let theme = $.cookie('theme');

    if (jqueryts.storage.cookie.getRaw("theme")==="dark"){
        try {
            $(".menu_sub_dark").addClass("ds-none")
            $(".menu_sub_light").removeClass("ds-none")
        } catch (e) {
            logError(e)
        }
    } else {
        try {
            $(".menu_sub_light").addClass("ds-none")
            $(".menu_sub_dark").removeClass("ds-none")
        } catch (e) {
            logError(e)
        }
    }
})